import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=8523ec16&scoped=true&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=8523ec16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8523ec16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8523ec16')) {
      api.createRecord('8523ec16', component.options)
    } else {
      api.reload('8523ec16', component.options)
    }
    module.hot.accept("./NotFoundComponent.vue?vue&type=template&id=8523ec16&scoped=true&", function () {
      api.rerender('8523ec16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Errors/NotFoundComponent.vue"
export default component.exports